import { ROLES, hasAnyRole, hasOnlyOneOfRoles } from '../../utils/roles';

const ALLOWED_ROLES_INVITE = [ROLES.ROLE_OWNER, ROLES.ROLE_ADMINISTRATOR, ROLES.ROLE_TECHNICAL];
const EXCLUSIVE_HIDDEN_ROLES = [ROLES.ROLE_FINANCE, ROLES.ROLE_SALES_CS, ROLES.ROLE_READ_ONLY];

const ALLOWED_ROLES_VIEW_TABLE = [
  ROLES.ROLE_OWNER,
  ROLES.ROLE_ADMINISTRATOR,
  ROLES.ROLE_FINANCE,
  ROLES.ROLE_TECHNICAL,
  ROLES.ROLE_READ_ONLY,
];

const ALLOWED_ROLES_MANAGE_COLLABORATION = [ROLES.ROLE_OWNER, ROLES.ROLE_ADMINISTRATOR];

export function canInviteCollaborator(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];

  if (hasAnyRole(safeRoles, ALLOWED_ROLES_INVITE)) {
    return true;
  }

  if (hasOnlyOneOfRoles(safeRoles, EXCLUSIVE_HIDDEN_ROLES)) {
    return false;
  }

  return false;
}

export function canViewSplitPaymentsTable(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];
  return hasAnyRole(safeRoles, ALLOWED_ROLES_VIEW_TABLE);
}

export function canManageCollaboration(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];
  return hasAnyRole(safeRoles, ALLOWED_ROLES_MANAGE_COLLABORATION);
}
